function initSingleLocationMap() {
	if (document.getElementById("location-map")) {
	
		const mapContainer = document.getElementById("location-map"),
			mapIcon = mapContainer.getAttribute("data-map-icon"),
			mapData = JSON.parse(mapContainer.getAttribute("data-map"));

		const center = {
			lat: mapData.lat,
			lng: mapData.lng
		};

		// setup Map
		window.locationMap = new google.maps.Map(mapContainer, {
			center: {
				lat: center.lat,
				lng: (window.innerWidth > 992) ? center.lng - 0.02 : center.lng, // Adjust the map so the marker is off center
			},
			zoom: mapData.zoom,
			zoomControl: false,
			mapTypeControl: false,
			scaleControl: false,
			streetViewControl: false,
			rotateControl: false,
			fullscreenControl: false,
			styles: mapStyles,
		});

		// Add locations icons
		const iconData = {
			url: mapIcon,
			scaledSize: new google.maps.Size(45, 45),
			origin: new google.maps.Point(0, 0),
			anchor: new google.maps.Point(23, 23),
		}

		var marker = new google.maps.Marker({
			position: center,
			map: window.locationMap,
			icon: iconData,
		});
	}
}

function initAllLocationsMap() {
	if (document.getElementById("map-container")) {
	
		const mapContainer = document.getElementById("map-container"),
			mapIcon = mapContainer.getAttribute("data-map-icon"),
			mapData = JSON.parse(document.querySelector('.js-location-map').getAttribute('data-map'));

		// setup Map
		window.allLocationsMap = new google.maps.Map(mapContainer, {
			center: {
				lat: mapData.lat,
				lng: mapData.lng
			},
			zoom: mapData.zoom,
			zoomControl: false,
			mapTypeControl: false,
			scaleControl: false,
			streetViewControl: false,
			rotateControl: false,
			fullscreenControl: false,
			styles: mapStyles,
		});

		// Add locations icons
		const iconData = {
			url: mapIcon,
			scaledSize: new google.maps.Size(110, 110),
			origin: new google.maps.Point(0, 0),
			anchor: new google.maps.Point(23, 23),
		}

		$('.js-location-map').each(function(i, item) {
			const locMapData = $(item).data('map'),
				id = $(item).data('loc-id');

			var marker = new google.maps.Marker({
				position: {
					lat: locMapData.lat,
					lng: locMapData.lng,
				},
				map: window.allLocationsMap,
				icon: iconData,
			});
			marker.addListener('click', (e) => {
				mapZoomTo(window.allLocationsMap, 14, window.allLocationsMap.getZoom(), e.latLng);
				selectLocation(id, locMapData.lat, locMapData.lng);
			});
		})
	}
}

// Smooth zooming
// Parameters: map, level to zoom to, current zoom level, co-ords to pan to
function mapZoomTo(map, max, currentZoom, coords) {
	// Pan to coords
	if (coords) {
		map.panTo(coords);
	}

	// Zoom in
    if (currentZoom >= max) {
        map.setZoom(max);
    }
    else {
        z = google.maps.event.addListener(map, 'zoom_changed', function(event){
            google.maps.event.removeListener(z);
            mapZoomTo(window.allLocationsMap, max, currentZoom + 1);
        });
        setTimeout(function(){map.setZoom(currentZoom)}, 80);
    }
}  

// Select location from locations list
function selectLocation(id, lat, lng) {
	const location = $('.js-location[data-loc-id="' + id + '"]');
	if (location.length) {
		// Add active state
		$('.js-location').removeClass('is-active');
		location.addClass('is-active');
		
		// Scroll the location to top of list
		const locationOffset = location.position().top + 240;
		$('.locations').animate({'scrollTop': locationOffset + 'px'});
	} else {
		// If location doesn't exist, rerun the search
		const searchTerm = lat + ',' + lng;
		searchLocationsByTerm(searchTerm);
	}
}


const mapStyles = [
	{
	  "elementType": "geometry",
	  "stylers": [
		{
		  "color": "#f9f9f9"
		}
	  ]
	},
	{
	  "elementType": "labels.icon",
	  "stylers": [
		{
		  "visibility": "off"
		}
	  ]
	},
	{
	  "elementType": "labels.text.fill",
	  "stylers": [
		{
		  "color": "#031E57"
		}
	  ]
	},
	{
        "featureType": "landscape",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#F9F3EB"
            }
        ]
    },
	{
	  "featureType": "administrative.land_parcel",
	  "elementType": "labels.text.fill",
	  "stylers": [
		{
		  "color": "#031E57"
		}
	  ]
	},
	{
	  "featureType": "poi",
	  "elementType": "labels.text.fill",
	  "stylers": [
		{
		  "color": "#EFEFEF"
		}
	  ]
	},
	{
	  "featureType": "poi.park",
	  "elementType": "geometry",
	  "stylers": [
		{
		  "color": "#f9f9f9"
		}
	  ]
	},
	{
	  "featureType": "poi.park",
	  "elementType": "labels.text.fill",
	  "stylers": [
		{
		  "color": "#9e9e9e"
		}
	  ]
	},
	{
	  "featureType": "road",
	  "elementType": "geometry",
	  "stylers": [
		{
		  "color": "#EFEFEF"
		}
	  ]
	},
	{
	  "featureType": "road.arterial",
	  "elementType": "labels.text.fill",
	  "stylers": [
		{
		  "color": "#EFEFEF"
		}
	  ]
	},
	{
	  "featureType": "road.highway",
	  "elementType": "labels.text.fill",
	  "stylers": [
		{
		  "color": "#eeead2"
		}
	  ]
	},
	{
	  "featureType": "road.local",
	  "elementType": "labels.text.fill",
	  "stylers": [
		{
		  "color": "#9e9e9e"
		}
	  ]
	},
	{
	  "featureType": "transit.line",
	  "elementType": "geometry",
	  "stylers": [
		{
		  "color": "#EEEEEE"
		}
	  ]
	},
	{
	  "featureType": "water",
	  "elementType": "geometry",
	  "stylers": [
		{
		  "color": "#ffffff"
		}
	  ]
	},
	{
	  "featureType": "water",
	  "elementType": "labels.text.fill",
	  "stylers": [
		{
		  "color": "#9e9e9e"
		}
	  ]
	}
  ]